import { Radio, Typography } from "antd"

const { Text, Link } = Typography

export const SelectableCard = ({
  label,
  icon,
  value,
  selectedValue,
  onChange,
  disabled = false
}) => {
  const checked = value === selectedValue

  return (
    <div
      onClick={() => !disabled && onChange(value)}
      style={{
        border: `1px solid ${checked ? "#1677ff" : "#E1E1E2"}`,
        borderRadius: 12,
        padding: "10px 14px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        transition: "all 0.2s ease"
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        {icon}
        <Text strong>{label}</Text>
      </div>

      <Radio
        checked={checked}
        onChange={() => onChange(value)}
        onClick={(e) => e.stopPropagation()}
        disabled={disabled}
      />
    </div>
  )
}
